module.exports = __webpack_public_path__ + "static/media/logo_rlb.6a63a629.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo_rlb.png
// module id = 1627
// module chunks = 0